import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FiUserCheck,
  FiClipboard,
  FiBarChart,
  FiUsers,
  FiMapPin,
} from "react-icons/fi";
import { FaRupeeSign } from "react-icons/fa";
import Feature from "./Feature";

const featuresData = [
  {
    icon: FiUserCheck,
    iconBg: "#1F7CFF",
    heading: "User Access Management",
    text: "Create and manage user logins with role-based permissions.",
  },
  {
    icon: FiClipboard,
    iconBg: "#F75C4E",
    heading: "Ticket Management",
    text: "Track and resolve field service requests efficiently.",
  },
  {
    icon: FiBarChart,
    iconBg: "#191046",
    heading: "Custom FSR Reports",
    text: "Generate detailed field service reports as per your requirements.",
  },
  {
    icon: FiUsers,
    iconBg: "#FF1FB3",
    heading: "Attendance & Leave Management",
    text: "Monitor employee attendance and leave records with ease.",
  },
  {
    icon: FaRupeeSign,
    iconBg: "#5C4EF7",
    heading: "Expense Management",
    text: "Track and approve field-related expenses seamlessly.",
  },
  {
    icon: FiMapPin,
    iconBg: "#F7954E",
    heading: "Employee Tracking",
    text: "Monitor real-time location and movement of field employees.",
  },
];

function Features() {
  return (
    <Container className="py-5 text-center">
      <h3
        className="fw-bold text-uppercase"
        style={{ color: "#dc2626", fontSize: "18px" }}
      >
        TMS Solution
      </h3>
      <h2 className="fw-bold mb-4" style={{ fontSize: "36px", color: "#000" }}>
        Optimize Your Field Operations
      </h2>
      <p
        className="mb-5 d-flex flex-column align-items-center"
        style={{ color: "#4a5568", fontSize: "16px" }}
      >
        Fieldsathi provides an all-in-one platform to manage field teams, <br />
        track performance, and streamline workflows effectively.
      </p>
      <Row className="g-4">
        {featuresData.map((feature, index) => (
          <Col key={index} md={6} lg={4}>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.98 }}>
              <Feature
                {...feature}
                headingStyle={{ fontSize: "20px" }}
                textStyle={{ fontSize: "16px", color: "#4a5568" }}
              />
            </motion.div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Features;
